var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _line, _line2, _line3, _line4, _line5, _line6, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 153.3469 152.8704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke: #3e3e3e;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-3, .cls-4 {\n        fill: none;\n      }\n\n      .cls-5, .cls-2 {\n        fill: #3e3e3e;\n      }\n\n      .cls-3, .cls-4 {\n        stroke-linecap: round;\n      }\n\n      .cls-4 {\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.0741,76.7106c0,17.79-2.83,17.79-2.83,17.79h-.88s-2.83,0-2.83-17.79c0-17.78,2.83-17.78,2.83-17.78h.88s2.83,0,2.83,17.78Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.3641,94.5007H10.3641s-2.84,0-2.84-17.79c0-17.78,2.84-17.78,2.84-17.78h17s-2.83,0-2.83,17.78c0,17.79,2.83,17.79,2.83,17.79Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.3601,94.5038s-2.8346,0-2.8346-17.7882,2.8346-17.7882,2.8346-17.7882"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.0294,94.5038s-2.8346,0-2.8346-17.7882,2.8346-17.7882,2.8346-17.7882"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.6987,94.5038s-2.8346,0-2.8346-17.7882,2.8346-17.7882,2.8346-17.7882"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129.5441,76.7106c0,17.79-2.83,17.79-2.83,17.79h-.8799s-2.83,0-2.83-17.79c0-17.78,2.83-17.78,2.83-17.78h.8799s2.83,0,2.83,17.78Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.5541,76.7106c0,17.79-2.83,17.79-2.83,17.79h-16.715s2.535,0,2.535-17.79c0-17.78-2.83-17.78-2.83-17.78h17.01s2.83,0,2.83,17.78Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.7192,94.5038s2.8346,0,2.8346-17.7882-2.8346-17.7882-2.8346-17.7882"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.0499,94.5038s2.8346,0,2.8346-17.7882-2.8346-17.7882-2.8346-17.7882"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.3806,94.5038s2.8346,0,2.8346-17.7882-2.8346-17.7882-2.8346-17.7882"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 147.4692,
    y1: 76.7156,
    x2: 148.8963,
    y2: 76.7156
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 119.9042,
    y1: 76.7156,
    x2: 122.4453,
    y2: 76.7156
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 99.8743,
    y1: 76.7156,
    x2: 107.763,
    y2: 76.7156
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 46.2638,
    y1: 76.7156,
    x2: 54.2744,
    y2: 76.7156
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 31.5815,
    y1: 76.7156,
    x2: 34.0992,
    y2: 76.7156
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5.1932,
    y1: 76.7156,
    x2: 6.6656,
    y2: 76.7156
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.9226,117.2505s3.057-12.0096,4.3765-13.5529c.2588-2.2471-.5647-7.2941-.5647-7.2941l-3.4118-4.447s-6.7076,7.9319-12.3529,5.7176c-9.9882-3.9176-13.9764-17.4235-14.1176-19.0588s-.2353-5.6823,3.0588-5.847c1.834-.0917,5.55-.2148,6.5176.3765,2.1176,1.2941,1.0824,7.9765,1.0824,7.9765,0,0,1.6827.4693,2.6353.9412l2.5412,1.2588,3.2706-4.0588s1.9828-7.3176,5.5294-8.7647c1.6023-.6537,4.6588-.4941,4.6588-.4941,0,0,1.7197-1.7707,2.8632-2.5359.6088-.4074,2.4843-1.052,3.5956-1.3112,0,0-3.4118-16.7647,6.4294-16.7647"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41.4874,83.3211s3.1059-.7412,6.9412,1.9176,3.6,5.3412,3.6,5.3412c0,0-2.6353.3529-6.1647-2.0941s-4.3765-5.1647-4.3765-5.1647Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M53.1344,89.9211s2.8235-2.1882,3.9294-3.5765,2.5176-3.9294,2.5176-3.9294v-3.5294s-2.6353,1.5765-3.5529,2.2588-2.8941,3.1765-2.8941,3.1765v5.6Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M75.4638,75.0623v7.1294s-.4609,3.1087-5.1176,3.2471c-7.1294.2118-11.7529-9.847-11.7529-9.847,0,0,.3882-3.1059,5.6823-3.1059s11.1882,2.5765,11.1882,2.5765Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.3461,87.6976s.3529,4.3412-2.6118,4.3412-4.9412-3.3176-4.9412-3.3176c0,0,2.5059.2471,4.0588.0353s3.4941-1.0588,3.4941-1.0588Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.3592,93.7182s-.2159,3.7177-2.7262,3.3661c-2.5103-.3515-3.7905-3.3951-3.7905-3.3951,0,0,2.0925.5063,3.4326.5112s3.0841-.4822,3.0841-.4822Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.726,99.6583s-.711,3.6554-3.1518,2.9714c-2.4408-.684-3.3025-3.8714-3.3025-3.8714,0,0,2.006.7816,3.3334.9655s3.1209-.0656,3.1209-.0656Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M71.5579,68.0976s-1.9059.0353-3.1765,1.1294-2.2235,2.4353-2.2235,2.4353c0,0,2.5059-.5647,3.5647-1.3765s1.8353-2.1882,1.8353-2.1882Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M72.7932,59.9447s.5882.7294,1.4353,1.1823c.7734.4135,1.6706.6295,1.6706.6295,0,0-1.0399.8181-2.1529.4471-1.3412-.4471-.9529-2.2588-.9529-2.2588Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.1461,117.2505s-3.057-12.0096-4.3765-13.5529c-.2588-2.2471.5647-7.2941.5647-7.2941l3.4118-4.447s6.7076,7.9319,12.3529,5.7176c9.9882-3.9176,13.9764-17.4235,14.1176-19.0588s.2353-5.6823-3.0588-5.847c-1.834-.0917-5.55-.2148-6.5176.3765-2.1176,1.2941-1.0824,7.9765-1.0824,7.9765,0,0-1.6827.4693-2.6353.9412l-2.5412,1.2588-3.2706-4.0588s-1.9828-7.3176-5.5294-8.7647c-1.6023-.6537-4.6588-.4941-4.6588-.4941,0,0-1.7197-1.7707-2.8632-2.5359-.6088-.4074-2.4843-1.052-3.5956-1.3112,0,0,3.4118-16.7647-6.4294-16.7647"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M112.5814,83.3211s-3.1059-.7412-6.9412,1.9176-3.6,5.3412-3.6,5.3412c0,0,2.6353.3529,6.1647-2.0941s4.3765-5.1647,4.3765-5.1647Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M100.9343,89.9211s-2.8235-2.1882-3.9294-3.5765-2.5176-3.9294-2.5176-3.9294v-3.5294s2.6353,1.5765,3.5529,2.2588,2.8941,3.1765,2.8941,3.1765v5.6Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M78.605,75.0623v7.1294s.4609,3.1087,5.1176,3.2471c7.1294.2118,11.7529-9.847,11.7529-9.847,0,0-.3882-3.1059-5.6823-3.1059s-11.1882,2.5765-11.1882,2.5765Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M77.7226,87.6976s-.3529,4.3412,2.6118,4.3412,4.9412-3.3176,4.9412-3.3176c0,0-2.5059.2471-4.0588.0353s-3.4941-1.0588-3.4941-1.0588Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M77.7096,93.7182s.2159,3.7177,2.7262,3.3661,3.7905-3.3951,3.7905-3.3951c0,0-2.0925.5063-3.4326.5112s-3.0841-.4822-3.0841-.4822Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M77.3428,99.6583s.711,3.6554,3.1518,2.9714,3.3025-3.8714,3.3025-3.8714c0,0-2.006.7816-3.3334.9655s-3.1209-.0656-3.1209-.0656Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M82.5108,68.0976s1.9059.0353,3.1765,1.1294,2.2235,2.4353,2.2235,2.4353c0,0-2.5059-.5647-3.5647-1.3765s-1.8353-2.1882-1.8353-2.1882Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M81.2755,59.9447s-.5882.7294-1.4353,1.1823c-.7734.4135-1.6706.6295-1.6706.6295,0,0,1.0399.8181,2.1529.4471,1.3412-.4471.9529-2.2588.9529-2.2588Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M112.4295,76.4006c.1188.92.1254,1.79.1055,2.29-.5938-.06-1.0952-.18-1.2205-.32-.3497-.38-.574-2.03-.4552-2.77.0792-.49.5806-.75,1.1809-.86.1386.41.3035,1.02.3893,1.66Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M116.613,78.4606c-.1055.14-.4552.23-.9105.26.0132-.5.0066-1.38-.1121-2.32-.0858-.66-.2639-1.29-.4024-1.7,1.7549.23,1.6691,1.29,1.6691,1.29,0,0,.1121,1.99-.2441,2.47Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M114.7677,78.7206c-.4355.05-.9786.03-1.4481-.03.017-.5.0113-1.37-.0905-2.29-.0735-.64-.215-1.25-.3338-1.66.2546-.07.5261-.09.7863-.09.2432,0,.4582.02.6449.05.1188.41.2715,1.04.345,1.7.1018.94.1075,1.82.0962,2.32Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41.6008,76.4006c-.1188.92-.1254,1.79-.1055,2.29.5938-.06,1.0952-.18,1.2205-.32.3497-.38.574-2.03.4552-2.77-.0792-.49-.5806-.75-1.1809-.86-.1386.41-.3035,1.02-.3893,1.66Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37.4173,78.4606c.1055.14.4552.23.9105.26-.0132-.5-.0066-1.38.1121-2.32.0858-.66.2639-1.29.4024-1.7-1.7549.23-1.6691,1.29-1.6691,1.29,0,0-.1121,1.99.2441,2.47Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M39.2143,78.7206c.4355.05.9786.03,1.4481-.03-.017-.5-.0113-1.37.0905-2.29.0735-.64.215-1.25.3338-1.66-.2546-.07-.5261-.09-.7863-.09-.2432,0-.4582.02-.6449.05-.1188.41-.2715,1.04-.345,1.7-.1018.94-.1075,1.82-.0962,2.32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.ce0187d08c268ddac10ea5a50e2d72a8.svg";
export { ForwardRef as ReactComponent };